<template>
    <div>
        <div class="costAllocation-title">
            <div>{{$t('Bill.CostAllocation.title')}}</div>
            <div>
                <Button type="primary" @click="addOrUpdateHandle">{{ $t("BillingServices.add") }}</Button>
                <add-or-update-cost-allocation v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-cost-allocation>
            </div>
        </div>
        <template>
            <table-cost-allocation></table-cost-allocation>
        </template>
    </div>
</template>

<script>
    import TableCostAllocation from '../cost_allocation/TableCostAllocation'
    import AddOrUpdateCostAllocation from '../cost_allocation/AddOrUpdateCostAllocation'

    export default {
        name: 'CostAllocation',
        components: {
            TableCostAllocation,
            AddOrUpdateCostAllocation
        },
        data(){
            return {
                addOrUpdateVisible:false
            }
        },
        methods:{
            // 添加
            /**********************************************************/
            addOrUpdateHandle:function(){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$router.push({path:'/ebilling/addOrUpdateCostAllocation/'});
                })
            }
        }
    }
</script>

<style scoped>
    .costAllocation-title
    {
        width: 100%;
        font-size: 13px;
        background-color: #fff;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .costAllocation-title>div:nth-child(1)
    {
        float:left;
    }
    .costAllocation-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
</style>



// WEBPACK FOOTER //
// src/components/ebilling/cost_allocation/CostAllocation.vue